export default {
  index: 'billing-list-view',
  settle: 'billing-settle-view',
};
